import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { CurrencyRender } from '@framework/ui/components/currency/CurrencyRender.tsx';
import { CopyableId } from '@framework/ui/components/table/CopyableId.tsx';
import { Space } from 'antd';
import {
  type ColumnGroupType,
  type ColumnsType,
  type ColumnType,
} from 'antd/es/table';
import { type EnumCodStatoPagamento } from './EnumCodStatoPagamento.tsx';
import { PaymentStateTag } from './PaymentStateTag.tsx';

export const paymentsColumnsBase = {
  codice: {
    title: t('payment-columns.codice', 'Codice'),
    dataIndex: 'codice',
    key: 'codice',
    render: (_, record) => {
      if (record.iuv) {
        return (
          <Space>
            <b>IUV</b>
            {record.iuv}
            <CopyableId id={record.iuv} />
          </Space>
        );
      }
      if (record.bolloRid) {
        return (
          <Space>
            <b>RID</b>
            {record.bolloRid}
            <CopyableId id={record.bolloRid} />
          </Space>
        );
      }
      return null;
    },
  },
  valore: {
    title: t('payment-columns.importo', 'Importo'),
    dataIndex: 'valore',
    key: 'valore',
    align: 'right',
    render: (_, record) => <CurrencyRender value={record.valore} />,
  },
  stato: {
    title: t('payment-columns.stato-pagamento', 'Stato Pagamento'),
    dataIndex: 'stato',
    key: 'stato',
    render: (_, record) => (
      <PaymentStateTag
        state={record.codStatoPagamento as EnumCodStatoPagamento}
      />
    ),
  },
} satisfies Record<
  string,
  | ColumnGroupType<PagamentoWithDettaglioDTO>
  | ColumnType<PagamentoWithDettaglioDTO>
>;

export const paymentsColumns: ColumnsType<PagamentoWithDettaglioDTO> = [
  paymentsColumnsBase.stato,
  paymentsColumnsBase.valore,
  paymentsColumnsBase.codice,
];

export const paymentsColumnsMobile: ColumnsType<PagamentoWithDettaglioDTO> = [
  paymentsColumnsBase.stato,
  paymentsColumnsBase.valore,
  paymentsColumnsBase.codice,
];
